import { Box, Heading, Table, Tbody } from '@chakra-ui/react'
import { Field, SectionTypeDef } from '@micin-jp/chicken-schema'

import { checkVisibleIf } from './checkVisibleIf'
import { PrintField } from './PrintField'
import { FieldValue } from '../../types'
import { FlattenFieldMap } from '../../utils/getFlattenFields'

type Props = {
  section: Field & { typeDef: SectionTypeDef }
  fieldValues: FieldValue[]
  fieldMap: FlattenFieldMap
}

export const PrintSection: React.FC<Props> = ({
  section,
  fieldValues,
  fieldMap,
}) => {
  // visibleIf条件をチェック
  if (!checkVisibleIf(section, fieldValues, fieldMap)) {
    return null
  }

  const sectionFields = section.typeDef.fields

  return (
    <Box className="print-section">
      {/* H2: セクション名 */}
      <Heading
        as="h2"
        fontSize="lg"
        fontWeight="bold"
        mb="2"
        className="print-section-title"
      >
        {section.name}
      </Heading>

      {/* フィールド一覧 */}
      <Table
        variant="unstyled"
        className="print-field-table"
        sx={{
          borderCollapse: 'collapse',
          width: '100%',
          border: '2px solid black',
        }}
      >
        <Tbody>
          {sectionFields.map(field => (
            <PrintField
              key={field.fid}
              field={field}
              fieldValues={fieldValues}
              fieldMap={fieldMap}
              index={1}
            />
          ))}
        </Tbody>
      </Table>
    </Box>
  )
}
